module.exports = __webpack_public_path__ + "img/image6.375d279e.png";